<template>
  <div class="contact-form-content">
    <div class="contact-header">
      <h2 class="contact-title">お問い合わせ</h2>
      <button class="close-button" @click="$emit('close')">
        <span>&times;</span>
      </button>
    </div>
    <div class="contact-body">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSekCIBs3HywNdohUOa_lQQx6eAlT8xOOQDpFOj0TITU-pMLPg/viewform?embedded=true"
        width="100%"
        height="100%"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        class="google-form-iframe"
      >
        読み込んでいます…
      </iframe>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ContactForm',
  emits: ['close']
});
</script>

<style scoped>
.contact-form-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.contact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.contact-title {
  font-size: 15px;
  font-weight: bold;
  color: #2d3748;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #718096;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.close-button:hover {
  background-color: #e2e8f0;
  color: #2d3748;
}

.contact-body {
  flex: 1;
  overflow: hidden;
  position: relative;
  min-height: 0;
}

.google-form-iframe {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
}

/* スマートフォン対応 */
@media (max-width: 768px) {
  .contact-title {
    font-size: 14px;
  }
  
  .close-button {
    font-size: 24px;
    width: 28px;
    height: 28px;
  }
}
</style>
